import { provideHttpClient } from "@angular/common/http";
import { ApplicationConfig } from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideMonacoEditor } from "ngx-monaco-editor-v2";
import { provideRouter } from '@angular/router';
import { MainComponent } from "./main/main.component";
import config from '../../auth_config.json';
import { provideAuth0 } from '@auth0/auth0-angular';
import { UserListComponent } from "./user-list/user-list.component";

let routes = [
  {
    path: '',
    component: UserListComponent
  }
]


const { domain, clientId, authorizationParams, apiUri, errorPath } = config as {
  domain: string;
  clientId: string;
  authorizationParams: any;
  apiUri: string;
  errorPath: string;
};

export const environment = {
  production: false,
  auth: {
    domain,
    clientId,
    authorizationParams: authorizationParams,
    errorPath,
  },
  httpInterceptor: {
    allowedList: [`${apiUri}/*`],
  },
};
authorizationParams.redirect_uri = window.location.origin;


export const appConfig: ApplicationConfig = {
    providers: [ provideAuth0(environment.auth), provideRouter(routes), provideHttpClient(), provideAnimationsAsync(), provideMonacoEditor({
      onMonacoLoad: () => console.log('Monaco Editor loaded')
    })],
  };
  